export default __webpack_public_path__ + "static/media/github-logo.cb737ee8.svg";